import React from 'react';
import { ArrowRight } from 'lucide-react';
import { CALCUL_BASE_PATH } from '../../calcul/calculConstants';
import styles from './TutorBand.module.css';

// Student-facing pages stay ad-free: a tutor's link opens play, print or the report.
const STUDENT_SEGMENT = /\/(jouer|imprimer|rapport)(\/|$)/i;
const CALCUL_PREFIX = new RegExp(`^${CALCUL_BASE_PATH}(/|$)`, 'i');

/** `/calcul/*` pages that carry the « Tu es prof particulier ? » band. */
export const showsCalculTutorBand = (pathname) => CALCUL_PREFIX.test(pathname) && !STUDENT_SEGMENT.test(pathname);

/** One line for tutors on a public tool page → the matching live landing. */
export default function TutorBand({ landing }) {
  const copy = landing.copy.tutorBand;
  return (
    <aside className={styles.band} aria-label={copy.title}>
      <p className={styles.text}><strong>{copy.title}</strong> {copy.body}</p>
      <a className={styles.link} href={landing.canonical}>{copy.link}<ArrowRight size={16} aria-hidden="true" /></a>
    </aside>
  );
}
